import { lazyPage, type ModulePlugin } from "@keel/core";
import { ProductionTile } from "./Tile";

const orders = () => import("./Orders");
const boms = () => import("./Boms");
const Overview = lazyPage(() => import("./Overview"), "Overview");
const OrdersList = lazyPage(orders, "ProductionOrdersList");
const NewOrder = lazyPage(orders, "NewProductionOrder");
const OrderPage = lazyPage(orders, "ProductionOrderPage");
const BomsList = lazyPage(boms, "BomsList");
const BomPage = lazyPage(boms, "BomPage");
const NewBom = lazyPage(boms, "NewBom");
const WorkCenters = lazyPage(() => import("./WorkCenters"), "WorkCenters");
const Planning = lazyPage(() => import("./Planning"), "Planning");
const ShopFloor = lazyPage(() => import("./ShopFloor"), "ShopFloor");

/** Manufacturing (optional module): BOMs, production orders, MRP, capacity, shop floor. */
const plugin: ModulePlugin = {
  key: "manufacturing",
  records: { ProductionOrder: "/production-orders/" },
  help: () => import("./help"),
  nav: [
    {
      group: "Manufacturing",
      items: [
        {
          to: "/manufacturing",
          label: "Production",
          icon: "factory",
          perm: "manufacturing.orders.read",
          end: true,
        },
        {
          to: "/production-orders",
          label: "Production orders",
          icon: "cog",
          perm: "manufacturing.orders.read",
        },
        { to: "/shop-floor", label: "Shop floor", icon: "play", perm: "manufacturing.orders.read" },
        { to: "/planning", label: "Planning (MRP)", icon: "calendar", perm: "manufacturing.orders.read" },
        { to: "/boms", label: "Bills of materials", icon: "tree", perm: "manufacturing.boms.read" },
        { to: "/work-centers", label: "Work centres", icon: "gauge", perm: "manufacturing.boms.read" },
      ],
    },
  ],
  routes: [
    { path: "/manufacturing", element: <Overview /> },
    { path: "/production-orders", element: <OrdersList /> },
    { path: "/production-orders/new", element: <NewOrder /> },
    { path: "/production-orders/:id", element: <OrderPage /> },
    { path: "/boms", element: <BomsList /> },
    { path: "/boms/new", element: <NewBom /> },
    { path: "/boms/:id", element: <BomPage /> },
    { path: "/work-centers", element: <WorkCenters /> },
    { path: "/planning", element: <Planning /> },
    { path: "/shop-floor", element: <ShopFloor /> },
  ],
  commands: [
    ["New production order", "/production-orders/new", "plus", "manufacturing.orders.write"],
    ["Production orders", "/production-orders", "cog", "manufacturing.orders.read"],
    ["Run MRP planning", "/planning", "calendar", "manufacturing.orders.read"],
    ["Shop floor", "/shop-floor", "play", "manufacturing.orders.read"],
    ["Bills of materials", "/boms", "tree", "manufacturing.boms.read"],
    ["New bill of materials", "/boms/new", "plus", "manufacturing.boms.write"],
    ["Work centres & capacity", "/work-centers", "gauge", "manufacturing.boms.read"],
    ["Production overview", "/manufacturing", "factory", "manufacturing.orders.read"],
  ],
  sources: { production_order: "/production-orders/" },
  dashboardTiles: [
    {
      key: "manufacturing",
      section: "manufacturing",
      perm: "manufacturing.orders.read",
      component: ProductionTile,
    },
  ],
};
export default plugin;
